import { NotificationItem } from "../notificationItem";

interface Props {
  count: number | undefined;
  showNotifications: boolean;
  color?: string;
  small?: boolean;
}

/**
 * Notification item to display a number in a circle.
 * @param interface
 * @returns a colored circle with a count in white text.
 */
export const NotificationItemNumber = ({ count, showNotifications, color = "bg-error", small = false }: Props) => {
  const showStaticNumber = count !== undefined && count > 99;
  const staticNumber = "99+";

  return (
    <div className={`${showNotifications ? "flex" : "hidden"}`}>
      <NotificationItem
        text={showStaticNumber ? staticNumber : count?.toString() ?? "0"}
        color={color}
        small={small || showStaticNumber}
        largeBox={showStaticNumber}
      />
    </div>
  );
};
